import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./actions";
import utilityReducer from "./utilitySlice";
import roamingReducer from "./roamingSlice";
import assistantReducer from "./assistantSlice";
import nojoomReducer from "./nojoomSlice";
import appReducer from "./appSlice";
import cdrReducer from "./cdrSlice";

import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import cdrSlice from "./cdrSlice";

const persistConfig = {
  key: "udata",
  storage,
  blacklist: ["roamingData", "nojoomData", "utilityData"],
};
const reducers = combineReducers({
  userdata: userReducer,
  utilityData: utilityReducer,
  roamingData: roamingReducer,
  assistantData: assistantReducer,
  nojoomData: nojoomReducer,
  appData: appReducer,
  cdrData: cdrReducer
});
const persistedReducer = persistReducer(persistConfig, reducers);

export default configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
